import { i18n } from '@lingui/core';
import { en, es } from 'make-plural/plurals';
import { DEFAULT_LANGUAGE, LOAD_SEARCH_PARAMS } from './constants';

export const LANGS = {
  en: { name: 'English', plurals: en },
  es: { name: 'Español', plurals: es },
};

const messagesGlob = import.meta.glob('./locales/**/*.mjs', { eager: true });

export const INIT_LANG = LOAD_SEARCH_PARAMS.lang in LANGS ? LOAD_SEARCH_PARAMS.lang : DEFAULT_LANGUAGE;

function loadMessagesSync() {
  for (const lang of Object.keys(LANGS)) {
    const path = `./locales/${lang}/messages.mjs`;

    if (messagesGlob[path]) {
      const module = messagesGlob[path];
      const messages = module.messages;

      if (messages) {
        i18n.load(lang, messages);
        i18n.loadLocaleData(lang, { plurals: LANGS[lang].plurals });
      }
    }
  }

  i18n.activate(INIT_LANG);
}

loadMessagesSync();

export function setLanguage(locale) {
  i18n.activate(locale);
}

export function isCurrentLanguage(locale) {
  return i18n.locale === locale;
}

export { i18n };
